function EventDetailList() {
    "use strict";
    this.Id = -1;
    this.IsConfirmed = -1;
    this.IsOpen = -1;
    this.StartDateUTC = new Date();
    this.StopDateUTC = new Date();
    this.ZoneId = -1;
    this.DeviceId = -1;
    this.ConfirmedDateUTC = new Date();
    this.DisplayLevel = -1;
    this.DisplayFlag = 0;
    this.ConfirmedByUserId = -1;
    this.ZoneTrackPointCount = -1;
    this.EnrolleeId = -1;
    this.Description = 'Unknown';
    this.MetaEventId = -1;
    this.Notes = '<div class="NotesIconProperty" onclick="enrolleeEventNotes_OnClick(0)">0</div>';
    this.NoteData = [];
    this.MeNotes = '<div class="MeNotesIconProperty" onclick="enrolleeMeEventNotes_OnClick(0)">0</div>';
    this.MeNoteData = [];
    this.MonitoredEvent = '<div>N/A</div>';
    this.MonitoredEventId = -1;
    this.SortId = '';
    this.EventData = null;
}
if (typeof exports !== 'undefined') {
    module.exports = EventDetailList;
}